
import React from 'react';

interface EmptyContentViewerProps {
  message?: string;
}

export function EmptyContentViewer({ message }: EmptyContentViewerProps) {
  return (
    <div className="flex items-center justify-center h-full text-gray-500 p-8">
      {message ? message : "No training content available"}
    </div>
  );
}
